import React from 'react';
import styles from './AdvtFullSize.module.css';
import { useGetParams } from '../../hooks/useGetParams';

const AdvtFullSize = React.memo(() => {
  const { title, qrCode1, qrCode2, sizeQR, titleFontSize, extraQrText } =
    useGetParams();

  return (
    <div className={styles.wrapper}>
      {title && (
        <div>
          <div
            className={styles.title}
            style={{ fontSize: `${titleFontSize}rem` }}
          >
            {title}
          </div>
        </div>
      )}

      <div className={styles.qrWrapper}>
        {qrCode1 && (
          <div
            className={styles.right}
            style={{
              minWidth: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              marginRight: extraQrText ? '2rem' : '6rem',
            }}
          >
            <img src={qrCode1} alt="" />
          </div>
        )}

        {qrCode2 && (
          <div
            className={styles.right}
            style={{
              minWidth: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              marginRight: extraQrText ? '2rem' : '6rem',
            }}
          >
            <img src={qrCode2} alt="" />
          </div>
        )}

        {extraQrText && <div className={styles.extraQrText}>{extraQrText}</div>}
      </div>
    </div>
  );
});

export default AdvtFullSize;
